const state = {
    newsEdit: null,
    newsDelete: null
}
export default state